export default __webpack_public_path__ + "static/media/loadingSquirtle.7de09bfa.gif";